import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./InputQtyPorsi.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import { FaEdit } from "react-icons/fa";
import { AddVendorPorsiEntity, VendorPorsiEntity } from "../../entities/VendorPorsiEntity";
import { PopUpPilihEntity } from "../../components/Popup/PopupPilihEntity";
import PopupPilih from "../../components/Popup/PopupPilih";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { format } from "date-fns";
import { VendorPorsiService } from "../../services/vendors_porsi";
import { LokasiService } from "../../services/lokasis";

export default function InputQtyPorsi() {
    // ========================================= GLOBAL CONTEXT =========================================  //
    const context = useContext(AppContext);
    const contextAccessToken = context.contextAccessToken;
    const contextShowAlertFunc = context.contextShowAlertFunc;
    const contextShowLoadingFunc = context.contextShowLoadingFunc;
    const contextUserEntity = context.contextUserEntity;
    const stateShowLoading = context.stateShowLoading
    // ========================================= GLOBAL CONTEXT =========================================  //


    // ========================================= STATE VIEW =========================================  //
    // const [excludeFilter, setExcludeFilter] = useState();
    // const [tableDataFilter, setTableDataFilter] = useState({});

    const [tableData, setTableData] = useState<VendorPorsiEntity[]>([]);

    const [selectedQtyPorsi, setSelectedQtyPorsi] = useState<VendorPorsiEntity | null>(null);
    const [selectedAddQtyPorsi, setSelectedAddQtyPorsi] = useState<AddVendorPorsiEntity | null>(null);

    const [showPopup, setShowPopup] = useState(false);
    const [showPopupPilih, setShowPopupPilih] = useState(false);
    const [popUpPilihEntity, setPopUpPilihEntity] = useState<PopUpPilihEntity>();
    const [timeNow, setTimeNow] = useState({ shift: 0, time: new Date() });

    // ========================================= STATE VIEW =========================================  //

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    const handleSelectLocation = async () => {
        contextShowLoadingFunc(true);
        setShowPopup(false)
        try {
            const resp = await LokasiService.GetAllLokasi();
            setPopUpPilihEntity(new PopUpPilihEntity({
                popupTitle: 'Pilih Lokasi',
                tableContent: resp,
                onClick: (row) => {
                    selectedQtyPorsi != null ?
                        setSelectedQtyPorsi((prevState: VendorPorsiEntity | null) => {
                            if (prevState == null) {
                                return null;
                            } else {
                                return new VendorPorsiEntity({
                                    ...prevState,
                                    id_lokasi: row.id,
                                    lokasi: row.lokasi
                                })
                            }
                        })
                        :
                        setSelectedAddQtyPorsi((prevState: AddVendorPorsiEntity | null) => {
                            return new AddVendorPorsiEntity({
                                ...prevState,
                                id_lokasi: row.id,
                                lokasi: row.lokasi
                            })
                        })
                        ; setShowPopup(true)
                },
                onClose: () => { setShowPopupPilih(false); setShowPopup(true) }
            }))
            setShowPopupPilih(true);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleAddNew = () => {
        let shift;
        const curr_hour = new Date().getHours()
        if (curr_hour >= 7 && curr_hour < 15) {
            shift = 1
        } else if (curr_hour >= 15 && curr_hour < 23) {
            shift = 2
        } else {
            shift = 3
        }
        setSelectedAddQtyPorsi({ tanggal: new Date() });
        setTimeNow((prev) => ({ ...prev, shift: shift }))
        setSelectedQtyPorsi(null);
        setShowPopup(true);
    }

    const handlePopupDetail = (row: VendorPorsiEntity) => {
        setSelectedQtyPorsi(row);
        setShowPopup(true)
    }

    const handleSaveAddQtyPorsi = async () => {
        if (selectedAddQtyPorsi == null || selectedAddQtyPorsi.id_lokasi == null || selectedAddQtyPorsi.qty_regular == null || selectedAddQtyPorsi.qty_vegetarian == null) return
        contextShowLoadingFunc(true);
        try {
            const resp = await VendorPorsiService.AddVendorsPorsi({ id_lokasi: selectedAddQtyPorsi.id_lokasi, qty_regular: selectedAddQtyPorsi.qty_regular, qty_vegetarian: selectedAddQtyPorsi.qty_vegetarian });
            await generateData();
            contextShowLoadingFunc(false);
            setSelectedQtyPorsi(null);
            setSelectedAddQtyPorsi(null);
            setShowPopup(false);
            contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleSaveUpdateQtyPorsi = async () => {
        contextShowLoadingFunc(true);
        try {
            if (selectedQtyPorsi == null) { throw new Error("qty porsi not selected") }
            const resp = await VendorPorsiService.UpdateVendorsPorsi(selectedQtyPorsi, { qty_regular: selectedQtyPorsi.qty_regular, qty_vegetarian: selectedQtyPorsi.qty_vegetarian });
            await generateData();
            contextShowLoadingFunc(false);
            setSelectedQtyPorsi(null);
            setShowPopup(false);
            contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleDeleteQtyPorsi = async () => {
        return contextShowAlertFunc(new AlertEntity({
            message: `Apakah anda yakin ingin menghapus Drop Off pada Lokasi ${selectedQtyPorsi?.lokasi} ?`,
            onOk: async () => {
                contextShowLoadingFunc(true);
                try {
                    if (selectedQtyPorsi == null) { throw new Error("qty porsi not selected") }
                    const resp = await VendorPorsiService.DeleteVendorsPorsi(selectedQtyPorsi);
                    await generateData();
                    contextShowLoadingFunc(false);
                    setSelectedQtyPorsi(null);
                    setShowPopup(false);
                    contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
                } catch (error: any) {
                    contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
                    contextShowLoadingFunc(false);
                }
            },
            withCancel: true,
            withOk: true,
            level: 2
        }))
    }

    const generateData = async () => {
        contextShowLoadingFunc(true);
        try {
            const resp = await VendorPorsiService.GetAllVendorsPorsi(null, null);
            setTableData(resp);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    };

    useEffect(() => {
        generateData();
    }, [contextAccessToken]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (new Date().getSeconds() === 3 || new Date().getSeconds() === 33) {
                let shift_now: number = 0
                let hours: number = new Date().getHours()
                if (hours >= 7 && hours < 15) {
                    shift_now = 1
                } else if (hours >= 15 && hours < 23) {
                    shift_now = 2
                } else {
                    shift_now = 3
                }
                setTimeNow({
                    shift: shift_now,
                    time: new Date()
                })
            }
        }, 1000);
        return () => {
            if (interval != null) {
                clearInterval(interval);
            }
        }
    }, []);

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    return (
        <>
            <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
                <Card
                    detailTitle="Input QTY Porsi"
                    detailColor="var(--secondary-color)"
                    backgroundImage={backgroundCard}
                    stateShow={true}
                    detailCard={
                        <> {contextUserEntity?.rolename.toLowerCase() == "vendor" &&
                            <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                                <div>
                                    <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                                    <button className="cardButton" onClick={() => handleAddNew()} >
                                        Add New
                                    </button>
                                </div>
                            </div>
                        }
                        </>
                    }
                />
                <div
                    style={{
                        height: "65vh",
                        overflow: "auto"
                    }}>
                    <table className="tableclickcell">
                        {tableData.length > 0 ?
                            <>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Tanggal</th>
                                        <th>Shift</th>
                                        <th>Lokasi Outlet</th>
                                        <th>Vendor</th>
                                        <th>Jumlah Porsi Reguler</th>
                                        <th>Jumlah Porsi Vegetarian</th>
                                        {contextUserEntity?.rolename.toLowerCase() == "vendor" &&
                                            <th>Edit</th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.map((row, idx) => {
                                        return <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{format(row.tanggal, "dd-MM-yyy")}</td>
                                            <td>{row.shift}</td>
                                            <td>{row.lokasi}</td>
                                            <td>{row.vendor}</td>
                                            <td>{row.qty_regular}</td>
                                            <td>{row.qty_vegetarian}</td>
                                            {contextUserEntity?.rolename.toLowerCase() == "vendor" &&
                                                <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><FaEdit /> Edit</td>
                                            }
                                        </tr>
                                    })}
                                </tbody>
                            </>
                            :
                            <>
                                <thead><tr><th>no data available yet!</th></tr></thead>
                            </>
                        }
                    </table>
                </div>

                {/* Popup Detail */}
                <Popup
                    setShowPopup={setShowPopup}
                    showPopup={showPopup}
                    popupTitle={selectedQtyPorsi == null ? "Add New" : `Edit ${format(selectedQtyPorsi?.tanggal, "yyyy-MM-dd")} Shift ${selectedQtyPorsi?.shift}`}
                    popupContent={
                        selectedQtyPorsi == null ?
                            <>
                                <div className={css.form}>
                                    <div className={css.containerleftright}>
                                        <div className={css.leftposition}>
                                            <div className={css.label}> Tanggal <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="date" value={format(timeNow.time, "yyyy-MM-dd")} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Lokasi Outlet<span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" readOnly
                                                value={selectedAddQtyPorsi?.lokasi ?? ""}
                                                onClick={handleSelectLocation}
                                            />
                                            <div className={css.label}> Jumlah Porsi Reguler <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="number" value={selectedAddQtyPorsi?.qty_regular ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddQtyPorsi((prevState: AddVendorPorsiEntity | null) => {
                                                        return new AddVendorPorsiEntity({
                                                            ...prevState,
                                                            qty_regular: parseInt(event.target.value)
                                                        })
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className={css.rightposition}>
                                            <div className={css.label}> Shift <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="number" value={timeNow.shift} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Vendor <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={contextUserEntity?.vendor ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Jumlah Porsi Vegetarian <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="number" value={selectedAddQtyPorsi?.qty_vegetarian ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddQtyPorsi((prevState: AddVendorPorsiEntity | null) => {
                                                        return new AddVendorPorsiEntity({
                                                            ...prevState,
                                                            qty_vegetarian: parseInt(event.target.value)
                                                        })
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className={css.buttons2}>
                                        <div className={css.left}>
                                            <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                                                Close
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="primaryButton"
                                                onClick={() => { handleSaveAddQtyPorsi() }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <>
                                <div className={css.form}>
                                    <div className={css.containerleftright}>
                                        <div className={css.leftposition}>
                                            <div className={css.label}> Tanggal <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="date" value={format(selectedQtyPorsi?.tanggal, "yyyy-MM-dd")} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Lokasi Outlet <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedQtyPorsi?.lokasi ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Jumlah Porsi Reguler <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="number" value={selectedQtyPorsi?.qty_regular ?? ""}
                                                onChange={(event) => {
                                                    setSelectedQtyPorsi((prevState: VendorPorsiEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new VendorPorsiEntity({
                                                                ...prevState,
                                                                qty_regular: parseInt(event.target.value)
                                                            })
                                                        }
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className={css.rightposition}>
                                            <div className={css.label}> Shift <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="number" value={selectedQtyPorsi?.shift ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Vendor <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedQtyPorsi?.vendor ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Jumlah Porsi Vegetarian <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="number" value={selectedQtyPorsi?.qty_vegetarian ?? ""}
                                                onChange={(event) => {
                                                    setSelectedQtyPorsi((prevState: VendorPorsiEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new VendorPorsiEntity({
                                                                ...prevState,
                                                                qty_vegetarian: parseInt(event.target.value)
                                                            })
                                                        }
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className={css.buttons2}>
                                        <div className={css.left}>
                                            <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                                                Close
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="secondaryButton" onClick={() => handleDeleteQtyPorsi()}>
                                                Delete
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="primaryButton"
                                                onClick={() => { handleSaveUpdateQtyPorsi() }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                />

                {popUpPilihEntity != null
                    ? <PopupPilih
                        showPopup={showPopupPilih}
                        setShowPopup={setShowPopupPilih}
                        popUpPilihEntity={popUpPilihEntity}
                    />
                    : <></>}


            </div>
        </>
    );
}
